import { ScriptDef, ScriptTheme } from '../../types';

export const MOVIE_FANZUI_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_089',
        name: '送灯',
        genre: 'movie',
        synopsis: '纪录片编导闵遥进山拍摄河湾"送灯"习俗：守灯人莫老三六十年来为溺亡者放灯，共七十三盏。摄像龚照把灯数与县志溺亡记录逐一比对，多出九盏，对应的九个人查无此人。水库管理站的退休职工劝他们别拍。当晚山里停电，回放的素材里，河湾水面亮起了第九十盏灯。',
        roles: [
            {
                name: '闵遥',
                roleType: '女主角',
                billing: 1,
                intro: '纪录片编导，毕业作业拍了半年没着落。采访提纲问的都是习俗源流，问题越问越短，最后只剩人名和年份。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '龚照',
                roleType: '男配角',
                billing: 2,
                intro: '摄像，扛机器的手比嘴稳。把七十三盏灯的素材逐帧标注，编着编着停了手，喊闵遥来看。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '小舟',
                roleType: '男配角',
                billing: 4,
                intro: '县志办实习生，帮龚照调了三天档案。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Horror, ScriptTheme.Mystery],
        heat: 41,
        baseScore: 7.2,
    },
    {
        id: 'SCRIPT_090',
        name: '凶宅试睡员',
        genre: 'movie',
        synopsis: '凶宅试睡员毛雨眠接下一单：民国老宅试睡三十天，全额提成五万。中介给她配了名搭档居延，两人夜夜拍到旧宅主人的遗物动静。第二十九天，她在镜子里看见穿水衣的人朝她鞠躬；次日她想把这件事说给居延，却发现这个搭档的入职档案，是三十天前她自己填的。',
        roles: [
            {
                name: '毛雨眠',
                roleType: '女主角',
                billing: 1,
                intro: '凶宅试睡员，睡过的凶宅两只手数得过来，方法是"把怕的东西写下来贴墙上"。这一单的监测曲线断了一截。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '居延',
                roleType: '男配角',
                billing: 2,
                intro: '中介派来的搭档，档案齐全，工牌崭新。记得毛雨眠说过的每句话，包括她自己不记得的。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '沈知晚',
                roleType: '女配角',
                billing: 3,
                intro: '老宅原主人的曾孙女，住在城另一头。问起祖上只回一句：我们家的事，到她这辈就断了。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Horror, ScriptTheme.Mystery, ScriptTheme.Urban],
        heat: 28,
        baseScore: 4.7,
    },
    {
        id: 'SCRIPT_091',
        name: '招魂笔',
        genre: 'movie',
        synopsis: '美术系学生甄问买到一支旧铅笔，室友认出是传说中被封存的"笔仙笔"，两人拉着学姐玩了一场只许问三个问题的笔仙游戏。此后画室墙上浮现只有铅笔才能擦掉的线条，画的都是同一张脸，而那支笔三年前就不该传下来。',
        roles: [
            {
                name: '甄问',
                roleType: '女主角',
                billing: 1,
                intro: '美术系大三学生，转专业来的，画得比谁都用力。速写本最后一页反复画着同一个侧脸。',
                // 2026-09-30 一二番同级修：与二番乐杜若同为 Lv.4（片酬同为 5 万）→ 一番升一级；
                // 门槛按台账 §3 Lv5 档 40/35/30 重推（补第三道 智慧），成长按 §4 Lv5 档 Σ6 均分 2/2/2
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 5,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '乐杜若',
                roleType: '女二号',
                billing: 2,
                intro: '甄问室友，校园怪谈的活字典，胆子靠嗓门撑。笔仙规则是她一条条写出来又一条一条念的，那一晚纸一直攥在她手里。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 2 },
            },
            {
                name: '尹眠',
                roleType: '女配角',
                billing: 3,
                intro: '大四学姐，三年前那届的知情人。游戏那晚她的手全程没碰笔，笔却在动。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Horror, ScriptTheme.Mystery],
        heat: 22,
        baseScore: 3.9,
    },
    {
        id: 'SCRIPT_146',  // 电影/犯罪悬疑黑色电影·版本一
        name: '拖网',
        genre: 'movie',
        synopsis: '东海渔村，退潮的海水把三年前"海上失踪"的报务员的尸体送了回来。老船长宋潮生当年在遇难认定书上签过字，钱各人领了各人散，报务员那一份落到他妻子手里，她如今守着灯塔，手边带一个学号的接班姑娘。县刑警缪岸挨个问下去，七个人对那晚的海况说法各不相同，口径却出奇一致：没有人落水。当年被按进海里的真相，被一张拖网重新捞了起来。',
        roles: [
            {
                name: '贺汀舟',
                roleType: '女配角',
                billing: 2,
                intro: '报务员的遗孀，灯塔守，常年替过往船只记灯号。丈夫失踪这三年，她的灯号簿一天没断过。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '缪岸',
                roleType: '男配角',
                billing: 3,
                intro: '县刑警，父亲是当年另一艘遇难船的船员。查案先算潮水，再对人证。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 2, wisdom: 2, temperament: 2 },
            },
            {
                name: '单小澜',
                roleType: '女配角',
                billing: 4,
                intro: '灯塔的接班姑娘，跟贺汀舟学了两年号，白天在码头补网，夜里上塔擦透镜。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { talent: 3, temperament: 2 },
            },
            {
                name: '小汐',
                roleType: '男配角',
                billing: 5,
                intro: '渔村码头帮工的小子，老船员们挨个来问话那天，他给每人续了一杯热茶。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Crime, ScriptTheme.Mystery, ScriptTheme.SeriousDrama],
        heat: 53,
        baseScore: 8.3,
    },
    {
        id: 'SCRIPT_147',  // 电影/犯罪悬疑黑色电影·版本二
        name: '灯下黑',
        genre: 'movie',
        synopsis: '县城出租车司机卞立秋的女儿被县领导外甥的越野车撞伤，对方托人递来私了的价码。十年前，卞立秋自己也在这条路上酒驾撞人，靠监控盲区和一笔封口钱把案子拖成了查不动的悬案；这一回他把躲监控的本事倒过来用，替女儿把对方钉进了程序里。市局刑警阙一鸣重走现场，发觉这案子办得太干净，干净得像有人教过。',
        roles: [
            {
                name: '阙一鸣',
                roleType: '男二号',
                billing: 2,
                intro: '市局刑警，办案先还原人的行动轨迹再查物证。调出了十年前那桩查不动的悬案，卷宗厚，结论文字少。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
            {
                name: '贺东来',
                roleType: '男配角',
                billing: 2,
                intro: '肇事者，县领导的外甥，案发后照常出入健身房。私了价码是照当年的旧账加了两成开的。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2, charm: 2 },
            },
            {
                name: '卞朵朵',
                roleType: '女二号',
                billing: 3,
                intro: '卞立秋的小女儿，姐姐住院后，探视的公交票根都收进铁盒。她认得那辆越野车。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Crime, ScriptTheme.Mystery, ScriptTheme.Urban],
        heat: 52,
        baseScore: 7.7,
    },
    {
        id: 'SCRIPT_148',  // 电影/犯罪悬疑黑色电影·版本三（低分反面教材）
        name: '第七证人',
        genre: 'movie',
        synopsis: '地产商人付明轩被控杀害合伙人，尸源、凶器、动机三样都指着他。王牌刑辩律师虞争鸣接案后连打七天官司，每天往庭上带一名新证人：更夫、钟点工、死者的司机、在押的同案犯，七天翻了七次。到第七天，庭上证明死者生前自己上过车库顶棚，故意杀人改成意外坠亡，付明轩当庭释放。散庭那晚，虞争鸣收到一条匿名短信，后面跟着这七天每名证人的合影，照片上的人互相都认识。',
        roles: [
            {
                name: '付明轩',
                roleType: '男主角',
                billing: 1,
                intro: '地产商人，被告席上西装笔挺，休庭时在座位上批合同，还起身跟旁听席上的人点头打招呼。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { temperament: 3, talent: 3, wisdom: 2 },
            },
            {
                name: '白鸥',
                roleType: '女配角',
                billing: 2,
                intro: '律所新人，七名证人的材料一份比一份厚，全归她装订。第三份往后她开始把疑点单独抄在便签上，抄完压在抽屉最底下。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Crime, ScriptTheme.Mystery, ScriptTheme.SeriousDrama],
        heat: 34,
        baseScore: 5.3,
    },
    {
        id: 'SCRIPT_149',  // 电影/犯罪悬疑黑色电影·版本四
        name: '心证',
        genre: 'movie',
        synopsis: '犯罪心理学博士许沉璧回到老家县城处理父亲的后事，在整理遗物时发现一份八年前的凶杀案卷宗——死者是她大学室友周小棠。案件以嫌疑人沈渡自杀结案，但许沉璧听审讯录音时听出了破绽：沈渡在录音中反复提到妻子生前说过一句话，而这句话与结案结论完全矛盾。她用自己的专业知识，一点点推翻了当年的定论。',
        roles: [
            {
                name: '许沉璧',
                roleType: '女主角',
                billing: 1,
                intro: '公安大学犯罪心理学博士，专长从审讯录音中提取心理痕迹。这次回家整理父亲遗物，翻出的那份卷宗让她第一次把专业用在了自己身上。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'wisdom', value: 70 },
                    { attr: 'temperament', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, wisdom: 3, temperament: 3, charm: 3 },
            },
            {
                name: '沈渡',
                roleType: '男配角',
                billing: 2,
                intro: '死者周小棠的丈夫，卡上的年纪停在结案那年。审讯录音里他反复说妻子生前说过"她会回来的"，这句话成了定罪的突破口。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '顾岚',
                roleType: '女配角',
                billing: 3,
                intro: '死者周小棠的闺蜜，案发当晚去过小棠家借东西后离开。她保留了案发后那年的台历，上面写着"小棠生日"。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '周小棠',
                roleType: '女配角',
                billing: 4,
                intro: '死者，许沉璧的大学室友，八年前那起凶杀案的受害者。卷宗里她的名字出现三十七次，每次后面都跟着"证人不适用"。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Crime, ScriptTheme.Mystery, ScriptTheme.Urban],
        heat: 55,
        baseScore: 8.1,
    },
    {
        id: 'SCRIPT_150',  // 电影/犯罪黑色边缘人·版本一
        name: '无声站台',
        genre: 'movie',
        synopsis: '城郊快递分拣站的员工大多是聋人，交接全靠手语和蜂鸣灯，站长苏念慈是站里少数的听人。年终盘点那天，一车送错的包裹卸在站台上，蜂鸣灯恰好坏了，没人听见车来。其中一件的收件人是甘向阳，寄件人是他失联多年的听人哥哥——四年前那场没结的仓库失火案，唯一的目击者就是这个人。',
        roles: [
            {
                name: '甘向阳',
                roleType: '男主角',
                billing: 1,
                intro: '聋人分拣员，分拣速度快过扫码枪，工资全站最高。攒四年配了人工耳蜗，配完那天起再没开过机，说要留着一句要紧的话听。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '苏念慈',
                roleType: '女主角',
                billing: 1,
                intro: '站长，听人，手语说到能做梦。四年前仓库失火那晚的夜班是她排的，检讨书她留了一张压在抽屉最上面，底下全是替聋人员工争绩效的申请材料。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '蒲实',
                roleType: '男二号',
                billing: 2,
                intro: '快递组长，听人，原来嫌手语慢，现在嫌自己眼睛慢。自己琢磨出看蜂鸣灯反光干活。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '劳悦',
                roleType: '女配角',
                billing: 3,
                intro: '助听器验配师，定期来做免费听力筛查。甘向阳每次都去，每次结果都一样，表是每次都重新填的。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '吕归',
                roleType: '男配角',
                billing: 4,
                intro: '分拣站夜班工友，从不说话，纸条写得比谁都多。货架分区的线是他用粉笔画的，谁摆错了位置，他自己走过去挪回来。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Crime, ScriptTheme.SeriousDrama, ScriptTheme.LifeStyle],
        heat: 47,
        baseScore: 7.9,
    },
    {
        id: 'SCRIPT_151',  // 电影/犯罪黑色边缘人·版本二
        name: '余火',
        genre: 'movie',
        synopsis: '东北老工业区的炉灰分拣站，环卫工连着三个冬天从灰里筛出烧不尽的遗物，件件带着同一家倒闭老厂的印记。今年开冬他又筛出一件，便报了案。案子落到管这片儿的片警霍铁生手里，走访从澡堂一路跑到退休工人家里，遗物一样样登了记——只有登记簿的最后一行空着：那件霍铁生没往局里交，是只缝着他本人名字的拳击手套。',
        roles: [
            {
                name: '霍铁生',
                roleType: '男主角',
                billing: 1,
                intro: '片警，转业前打过省队，左耳背是擂台留下的。走访每户自带茶叶，喝完就走，记录记满一摞本子。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2, wisdom: 2 },
            },
            {
                name: '佟大力',
                roleType: '男二号',
                billing: 2,
                intro: '澡堂搓澡工，力道全城有名，客人名单上半个是老厂退休科干。入冬双手裂口子，位置每次一样。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, stamina: 2, temperament: 2 },
            },
            {
                name: '梅白霜',
                roleType: '女配角',
                billing: 2,
                intro: '澡堂收银员，老厂会计的女儿，从灰里筛出来的那几样东西，她一眼说得出是哪一位的。父亲留下的那本私人台账她看得紧。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Crime, ScriptTheme.Mystery, ScriptTheme.Urban],
        heat: 53,
        baseScore: 7.8,
    },
    {
        id: 'SCRIPT_152',  // 电影/犯罪黑色边缘人·版本三
        name: '握手楼',
        genre: 'movie',
        synopsis: '南方某市白云村旧改，钉子户劳广仁的握手楼立在工地中央，楼里囤着全村的房产证和一本代记的失地款流水。十年前替村里记这本账的会计是劳广仁的哥哥，人淹在自家鱼塘里，结案写的是醉酒。开发商资金链断裂那晚，存放账册的铺面着了火，进村拍纪录片的财经记者缪云拍到有人往门上浇汽油。片警费平两头受气，回南天里案卷发了霉，十年前的溺亡和眼前的火烧案，一页一页并到了一起。',
        roles: [
            {
                name: '费平',
                roleType: '男主角',
                billing: 1,
                intro: '片警，白云村管了八年，村里人的小名都叫得出。执法记录仪常年多备一块电池，说不是拍事，是拍人。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '缪云',
                roleType: '女配角',
                billing: 2,
                intro: '财经记者，追旧改资金链两年，进村只扛一台手持摄影机，电池跟胶卷一样数着用。劳广仁的楼倒下时，围挡标语还在，她拍了两遍。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '阚承业',
                roleType: '男配角',
                billing: 3,
                intro: '开发商代表，谈判从不发火，发脾气的方式是换手表。烧账册那晚，监控里他的车没动过。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Crime, ScriptTheme.SeriousDrama, ScriptTheme.Urban],
        heat: 46,
        baseScore: 7.4,
    },
];
